module.exports = __webpack_public_path__ + "static/img/valueadd4.6e8db0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/valueadd4.png
// module id = nDWZ
// module chunks = 1